import { useRef } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { TSTFilterBar, TSTPagination, TSTTable } from "@impero-com/ui";

import { ClassificationAndRights } from "../types";

import { useClassificationsListTable } from "./useClassificationsListTable";

interface ClassificationsListProps {
    classifications: Array<ClassificationAndRights>;
}

export function ClassificationsList({
    classifications,
}: ClassificationsListProps) {
    const { t } = useTranslation();
    const { table } = useClassificationsListTable(classifications);
    const tableRef = useRef<HTMLTableElement>(null);

    return (
        <div>
            <TSTFilterBar<ClassificationAndRights>
                table={table}
                addLabel={t("FilterBar_AddFilter")}
                globalSearchLabel={t("FilterBar_GlobalSearchPlaceholder")}
                getFilterCountLabel={(count) =>
                    t("FilterBar_FiltersApplied", { count })
                }
                rowCountLabel={t("FilterBar_RowCount", {
                    count: table.getPrePaginationRowModel().rows.length,
                })}
                hideFiltersLabel={t("FilterBar_HideFilters")}
                clearAllLabel={t("FilterBar_ClearAll")}
                getFilterComponent={() => null}
            />
            <TSTTable
                tableRef={tableRef}
                table={table}
                noResultsFallback={t("NoResults")}
                noSourceRowsFallback={t("NoResults")}
            />
            <TSTPagination
                tableElement={tableRef}
                table={table}
                pageLabel={t("Pagination_Page")}
                getRowCountLabel={(shown, count) =>
                    t("Pagination_RowCount", { shown, count })
                }
                getSinglePageRowCountLabel={(count) =>
                    t("Pagination_RowCountSinglePage", { count })
                }
            />
        </div>
    );
}
